module.exports = __webpack_public_path__ + "img/lamp.8d8908a3.svg";